/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TagContainer.vue?vue&type=template&id=f272d43e&"
import script from "./TagContainer.vue?vue&type=script&lang=js&"
export * from "./TagContainer.vue?vue&type=script&lang=js&"
import style0 from "./TagContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports